import React, { useState, useRef } from 'react';
import { db } from '../../firebase';
import { collection, addDoc } from 'firebase/firestore';
import emailjs from '@emailjs/browser';
import './Contact.css';
import Navbar from '../../components/navigationbar/Navbar';
import Footer from '../../components/Footer/Footer';
import AdvertisementSection from '../../components/ReachOutForAdd/AdvertisementSection';

const Contact = () => {
  const form = useRef(); // Reference for the form
  const [formData, setFormData] = useState({
    from_name: '',    // Update to match form input names
    user_email: '',
    to_name: '',
    message: ''
  });

  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value  // Update to match new input names
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Store data in Firebase
      await addDoc(collection(db, 'contacts'), formData);
      setSubmitStatus('Thank you! Your message has been sent successfully.');

      // Send email using EmailJS
      emailjs
        .sendForm(
          'service_30irbgk', // Replace with your EmailJS Service ID
          'template_9qs9vf6', // Replace with your EmailJS Template ID
          form.current,
          'r75eB8XtExbAvA83n'   // Replace with your EmailJS Public Key
        )
        .then(
          () => {
            console.log('Email successfully sent!');
            setFormData({ from_name: '', user_email: '', to_name: '', message: '' }); // Reset form fields
          },
          (error) => {
            console.log('Failed to send email:', error.text);
            setSubmitStatus('Failed to send message. Please try again later.');
          }
        );

    } catch (error) {
      console.error('Error adding document: ', error);
      setSubmitStatus('Failed to send message. Please try again later.');
    }
  };

  return (
    <>
  <Navbar />
  <div className="contact-page">
    <div className="contact-page-header">
      <p>We are here to assist you! Reach out to us for any inquiries, membership information, or upcoming events.</p>
    </div>
    <div className="contact-page-content">
      <div className="contact-page-details">
        <h2>Get in Touch</h2>
        <p><strong>Email:</strong> <a href="mailto:gpaichalkaranji@gmail.com">gpaichalkaranji@gmail.com</a></p>
        <p><strong>Contact numbers:</strong></p>
        <p>Dr. Abhijit Bhosale - 9850112972</p>
        <p>Dr. Suhas Kumbhar - 9011327136</p>
        <p>Dr. Rahim Khan - 9970754788</p>
        <p><strong>Address:</strong> Ichalkaranji, Taluk - Hatkanangle, District - Kolhapur, Maharashtra, ZIP Code - 416115</p>
      </div>
      <div className="contact-page-form">
        <h2>Send Us a Message</h2>
        {submitStatus && <p className="contact-page-submit-status">{submitStatus}</p>}
        <form ref={form} onSubmit={handleSubmit}>
          <div className="contact-page-form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="from_name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
            />
          </div>
          <div className="contact-page-form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="user_email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              required
            />
          </div>
          <div className="contact-page-form-group">
            <label htmlFor="subject">Subject:</label>
            <input
              type="text"
              id="subject"
              name="to_name"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Subject"
              required
            />
          </div>
          <div className="contact-page-form-group">
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              rows="5"
              required
            ></textarea>
          </div>
          <button type="submit" className="contact-page-button">Send Message</button>
        </form>
      </div>
    </div>
    <div className="contact-page-map">
      <h2>Our Location</h2>
      <iframe
        title="GPA Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61143.22359308635!2d74.4640446!3d16.70431035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc0e265ba450af7%3A0x671b0ba88c556c2!2sIchalkaranji%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1729107413946!5m2!1sen!2sin" 
        width="100%"
        height="400"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>
    </div>
    <div>
      <AdvertisementSection/>
    </div>
  </div>
  <Footer />
</>

  );
};

export default Contact;
